/* eslint-disable camelcase */
import React, { useState } from 'react'
import {
  Popover,
  PopoverTrigger,
  PopoverContent
} from '../../../components/Popover'

import MemoCheck from '../Icons/Check'
import MemoDeleteOutline from '../Icons/DeleteOutline'

import { useInAppNotificationStyles } from '../../../hooks/styles/useInAppNotificationStyles'

import MemoMoreHoriz from '../Icons/MoreHoriz'
import { useTheme } from '../../../index'
import { useNotificationsHomeContext } from '../../context'

export const NotificationActions = ({ msg }) => {
  const [hoveredItem, setHoveredItem] = useState(null)
  const theme = useTheme()

  const { StyledMenuItem, threeDotsButtonStyle } = useInAppNotificationStyles()

  const {
    handlers: { handleMarkAsRead, handleDelete }
  } = useNotificationsHomeContext()

  const handleMenuItemClick = (action) => {
    if (action === 'markAsRead') {
      handleMarkAsRead(msg)
    } else if (action === 'delete') {
      handleDelete(msg)
    }
  }

  return (
    <div onClick={(e) => e.stopPropagation()} role='menu'>
      <Popover>
        <PopoverTrigger asChild>
          <button
            style={{
              ...threeDotsButtonStyle
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = 'rgba(0, 0, 0, 0.04)'
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = 'transparent'
            }}
          >
            <MemoMoreHoriz
              sx={{
                fontSize: '1.25rem',
                color: theme.palette.text.secondary
              }}
            />
          </button>
        </PopoverTrigger>

        <PopoverContent
          onClick={(e) => e.stopPropagation()}
          style={{
            backgroundColor: theme.palette?.background?.paper || '#fff',
            borderRadius: '8px',
            padding: '8px',
            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
            zIndex: 10000,
            minWidth: '150px'
          }}
          align='end'
          sideOffset={5}
        >
          <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
            {!msg?.isRead && (
              <StyledMenuItem
                onClick={(e) => {
                  e.stopPropagation()
                  e.preventDefault()
                  handleMenuItemClick('markAsRead')
                }}
                hoveredItem={hoveredItem}
                type='markAsRead'
                onMouseEnter={() => setHoveredItem('markAsRead')}
                onMouseLeave={() => setHoveredItem(null)}
              >
                <MemoCheck fontSize='small' />
                <span style={{ color: theme.palette.text.primary }}>
                  Mark as read
                </span>
              </StyledMenuItem>
            )}
            <StyledMenuItem
              onClick={(e) => {
                e.stopPropagation()
                e.preventDefault()
                handleMenuItemClick('delete')
              }}
              hoveredItem={hoveredItem}
              type='delete'
              onMouseEnter={() => setHoveredItem('delete')}
              onMouseLeave={() => setHoveredItem(null)}
            >
              <MemoDeleteOutline fontSize='small' />
              <span>Delete</span>
            </StyledMenuItem>
          </div>
        </PopoverContent>
      </Popover>
    </div>
  )
}
